import { useQuery } from "@tanstack/react-query";
import { apiWithoutCamelization } from "../../../api";
import urls from "../../../urls";
import type { TodosCanGenerateDocuments } from "../../../utils/backend-types";

function useTodoCanGenerateDocuments(
  todoId: number,
  handleErrorMessage: (message: string) => void
) {
  const { data, isLoading, error } = useQuery({
    queryKey: ["todo-can-generate-documents", { todoId }],
    queryFn: fetchTodoCanGenerateDocuments
  });

  async function fetchTodoCanGenerateDocuments() {
    const response =
      await apiWithoutCamelization.get<TodosCanGenerateDocuments>(
        urls.apiWithoutCamelization.todoCanGenerateDocuments(todoId)
      );
    if (response.data.document_generation_blocker) {
      handleErrorMessage(
        response.data.document_generation_blocker.message || ""
      );
    }
    return response.data;
  }

  return {
    todoCanGenerateDocuments: data,
    isTodoCanGenerateDocumentsLoading: isLoading,
    todoCanGenerateDocumentsError: error
  };
}

export { useTodoCanGenerateDocuments };
